import React from 'react';
import Helmet from 'react-helmet';
import { Query } from 'react-apollo';
import gql from 'graphql-tag';
import styled from 'styled-components';

import breakpoints from '../styles/breakpoints';

import { Loader } from '../components/Loader';
import { Error } from '../components/Error';
import Spacer from '../components/helpers/Spacer';

import Article from '../components/Article';
import GenerateMetaTags from '../components/GenerateMetaTags';
import HeroSearchSection from '../components/HeroSearchSection';
import PopularCategoriesSection from '../components/PopularCategoriesSection';
import CarPartsSearchSection from '../components/CarPartsSearchSection';
import CarBrandsListSection from '../components/CarBrandsListSection';
import ImageShortcutsSection from '../components/ImageShortcutsSection';
import ShortCutIconGridSection from '../components/ShortcutIconGridSection';
import { TransitionWrapper } from '../components/TransitionWrapper';

const GET_FRONT_PAGE = gql`
  query getFrontPage($frontPageId: Int!) {
    page: getWPPage(id: $frontPageId) {
      id
      title {
        rendered
      }
      excerpt {
        rendered
      }
      acf
    }
  }
`;

const FrontPageArticle = styled(Article)`
  margin: 0;

  ${breakpoints.medium`
    margin: 0;
  `};

  ${breakpoints.large`
    margin: 0;
  `};
`;

export default function FrontPage() {
  return (
    <TransitionWrapper>
      <Helmet>
        {GenerateMetaTags({
          title: 'Bildeler til din bil - Du får det du trenger hos oss',
          description:
            'Vi har alt du trenger av brukte bildeler. Forhandler også fabrikkoverhalte motorer og gearkasser. Snakk med oss når du skal ha deler til bilen din.'
        })}
      </Helmet>

      <Query
        query={GET_FRONT_PAGE}
        variables={{
          frontPageId: Number(process.env.REACT_APP_FRONT_PAGE_ID)
        }}
      >
        {({ loading, error, data }) => {
          if (loading) {
            return <Loader />;
          }

          if (error) {
            return <Error error={error} />;
          }

          if (!data.page) {
            //@todo: Redirect to 404?
            return <div>Ikke funnet</div>;
          }

          const { acf } = data.page;

          return (
            <FrontPageArticle>
              <HeroSearchSection
                title={acf.numbersearch_title}
                description={acf.numbersearch_description}
              />

              <Spacer />

              {acf.part_groups &&
                acf.part_groups.length > 0 && (
                  <>
                    <PopularCategoriesSection
                      categories={acf.part_groups.map((group, index) => {
                        return {
                          id: index,
                          image: group.part_groups_image.sizes.medium,
                          url: group.part_groups_url,
                          name: group.part_groups_name
                        };
                      })}
                    />

                    <Spacer />
                  </>
                )}

              <CarPartsSearchSection />

              <Spacer />

              <CarBrandsListSection
                brands={acf.cars.map((car, index) => {
                  return {
                    id: index,
                    url: car.cars_url,
                    name: car.cars_car_brand,
                    isFeatured: car.cars_is_featured
                  };
                })}
              />

              <Spacer />

              <ImageShortcutsSection
                shortcuts={acf.featured_posts.map((post, index) => {
                  const imgUrl = post.featured_posts_post_image
                    ? post.featured_posts_post_image.sizes.medium
                    : null;

                  return {
                    id: index,
                    url: `/aktuelt/${post.featured_posts_post.ID}`,
                    image: imgUrl,
                    title: post.featured_posts_post_title,
                    subtitle: post.featured_posts_post_subtitle
                  };
                })}
              />

              <Spacer />

              <ShortCutIconGridSection />
            </FrontPageArticle>
          );
        }}
      </Query>
    </TransitionWrapper>
  );
}
